import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Change,
  Reset,
} from "../../../store/async-actions/digitalmarketing/header";

import { useGetDashboardStatusesQuery } from "../../../Service/dashboard";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import DashTable from "./DashTable";
import DashTabs from "./DashTabs";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import DateRangePicker from "../../../Component/DigitalMarketing/Forms/DateRangePicker";
import Dropdown from "../../../Component/DigitalMarketing/Forms/Dropdown";
import { Button } from "@mui/material";
import { FiFilter } from "react-icons/fi";
import DialogModal from "../../../Component/DigitalMarketing/DialogModal";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../Component/DigitalMarketing/Toast";
import { useAddBulkCustomerMutation } from "../../../Service/customers";
import StageDetails from "./StageDetails";
import PermissionCheck from "../../../Component/PermissionCheck";
import { useGetIVFJourneysQuery } from "../../../Service/ivfJourneyStage";
import { useGetAllBranchesQuery } from "../../../Service/Masters";
import Loader from "../../../Component/DigitalMarketing/Loader";
export const initialJourney = {
  journeyStageName: "",
  description: "",
  steps: [],
};
function Ivf() {
  const [pagination, setpagination] = useState(1);
  const [lead, setLeads] = useState<any>({});
  const [filter, setFilter] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [show, setshow] = useState(false);
  const [Show, setShow] = useState(false);
  const [filteredValues, setFilteredValues] = useState(null);
  const [created, setCreated] = useState(false);

  const initialstate = {
    startDate: null,
    endDate: null,
  };

  const [date, setDate] = useState(initialstate);
  const [dateRange, setDateRange] = useState(initialstate);

  const [updated, setUpdated] = useState(false);
  const [source, setSource] = useState("");
  const dispatch = useDispatch<any>();
  const [journey, setJourney] = useState(initialJourney);

  const getStatus = useGetDashboardStatusesQuery();
  const [open, setOpen] = useState(false);
  const { open: open1, message, openSnackBar, type } = useSnackbar();
  const [deleted, setDeleted] = useState(false);
  const [stepdeleted, setStepdeleted] = useState(false);
  const { data: branchOptions } = useGetAllBranchesQuery({
    refetchOnMountOrArgChange: true,
  });
  const handleOpen = () => {
    setOpen(true);
  };
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const {
    data: journeys,
    isLoading,
    refetch,
  } = useGetIVFJourneysQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });

  const handleClose = () => {
    setOpen(false);
    setLeads({});
  };
  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    setpagination(1);
    refetch();
  }, [filter, searchValue]);
  // const { data: Leadslist, isLoading }: any = useGetDashboardCustomersQuery(
  //   pagi,
  //   {
  //     refetchOnMountOrArgChange: true,
  //   }
  // );

  useEffect(() => {
    dispatch(Reset());
  }, [dispatch]);

  const onFilter = (value) => {
    if (value === "All") {
      setFilter("");
    } else {
      setFilter(value);
    }
  };
  useEffect(() => {
    const data: any = {
      first: "Treatment Journey",
    };
    dispatch(Change(data));
  }, [dispatch]);
  // const onHandleChange = (event) => {
  //   const { name, value } = event.target;
  //   if (name === "date") {
  //     setDate({
  //       startDate: moment(value[0]).format("YYYY-MM-DD"),
  //       endDate: moment(value[1]).format("YYYY-MM-DD"),
  //     });
  //     setDateRange(value);
  //   } else if (name === "source") {
  //     setSource(value);
  //   }
  // };

  const ClearFilter = () => {
    setShow(false);
    setDate(initialstate);
    setDateRange(initialstate);
    // setParamsValue({ date: initialstate, source: "" });
    setSource("");
    setSearchValue("");
  };
  const OnChange = (event) => {
    const { name, value, files } = event.target;
    setLeads((prevState) => ({ ...prevState, [name]: files[0] }));
  };
  const ListFilter = () => {
    if (
      !date?.startDate ||
      date?.startDate === "Invalid date" ||
      date?.endDate !== "Invalid date"
    ) {
      setShow(true);
      setpagination(1);
    } else {
      openSnackBar("Please select end date!", "error");
    }
  };

  useEffect(() => {
    // console.log("created 11111111");
    if (created === true) {
      openSnackBar("Added successfully");

      setTimeout(() => {
        //  console.log("created 222222");

        refetch();
      }, 1000);
    }
  }, [created]);
  useEffect(() => {
    // console.log("updated 11111111");
    if (updated === true) {
      openSnackBar("Updated successfully");

      setTimeout(() => {
        //  console.log("updated 222222");

        refetch();
      }, 1000);
    }
  }, [updated]);
  useEffect(() => {
    // console.log("updated 11111111");
    if (deleted === true) {
      openSnackBar("Deleted successfully", "error");

      setTimeout(() => {
        //  console.log("updated 222222");

        refetch();
        setDeleted(false);
      }, 1000);
    }
  }, [deleted]);
  useEffect(() => {
    // console.log("deleted 11111111");
    if (stepdeleted === true) {
      openSnackBar("Step deleted successfully", "error");

      setTimeout(() => {
        //  console.log("updated 222222");

        refetch();
        setStepdeleted(false);
      }, 1000);
    }
  }, [stepdeleted]);
  useEffect(() => {
    // console.log(journey);
  }, [journey]);
  useEffect(() => {
    // console.log(journeys);
  }, [journeys]);
    
    if (isLoading) {
      return <Loader loading={true}/>;
    }
  return (
    <React.Fragment>
      <div>
        <Toast open={open1} type={type} message={message} />

        <Row className="mb-3">
          <Col md={5} className="mb-3">
            <SearchBox
              value={searchValue}
              onChange={(event) => onChangeSearch(event)}
            />
          </Col>
          {/* <Col md={6} className="d-flex mb-3 justify-content-between">
            
            <div className="filter f-14 mx-2 cursor">
            <Button variant="contained" onClick={ListFilter} id="btn-add">
                {" "}
                <FiFilter />
                &nbsp; Filter
              </Button>
            </div>
            {Show && (
              <p
                className="clear-filter f-14 mb-0 mt-1 mx-2 cursor"
                onClick={ClearFilter}
              >
                X Clear filters
              </p>
            )}
          </Col> */}
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <Button
                variant="contained"
                id="btn"
                onClick={() => {
                  setshow(!show);
                  setJourney(initialJourney);
                }}
              >
                {show ? "x Close" : "+ Add Stage"}{" "}
              </Button>
            </div>
          </Col>
        </Row>
        <div className="grid-container">
          <div className={show ? "item1" : "item1-full"}>
            <DashTable
              show={show}
              journeys={filteredValues ? filteredValues : journeys}
              setshow={setshow}
              setJourney={setJourney}
              deleted={deleted}
              openSnackBar={openSnackBar}
              setDeleted={setDeleted}
              refetch={refetch}
              updated={updated}
              setUpdated={setUpdated}
            />
            {!isLoading && (
              <Pagination
                setpagination={setpagination}
                pagination={pagination}
                data={journeys}
              />
            )}
          </div>
          {show ? (
            <div className="Customer-details mx-3 item2">
              <ul
                className="md-bord"
                style={{ height: "100%", maxHeight: "100%" }}
              >
                <StageDetails
                  journey={journey}
                  refetch={refetch}
                  branchOptions={branchOptions}
                  updated={updated}
                  setUpdated={setUpdated}
                  setJourney={setJourney}
                  created={created}
                  stepdeleted={stepdeleted}
                  setStepdeleted={setStepdeleted}
                  setCreated={setCreated}
                  cancel={
                    <Button
                      variant="contained"
                      id="btn-cancel"
                      className="me-2"
                      onClick={() => {
                        setshow(!show);
                        // setJourney(initialJourney);
                      }}
                    >
                      Cancel
                    </Button>
                  }
                  show={show}
                  setshow={setshow}
                />
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default React.memo(Ivf);
